import { css } from "styled-components";

const styles = css``;

export default styles;
